import React from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  List,
  ListItem,
  ListIcon,
  IconButton,
} from "@chakra-ui/react";
import { AiFillInfoCircle } from "react-icons/ai"; // Info icon
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

const SpentAmountPopover = ({ spentAmounts ,refundAmount,currencySymbol,title}) => {
  return (
    <Popover placement="left" trigger="hover" closeOnBlur={true}>
      {({ isOpen, onClose }) => (
        <>
          <PopoverTrigger>
            <IconButton
              icon={<AiFillInfoCircle />}
              aria-label="Show spent amounts"
              size={10}
              border="none"
              ml={2}
              colorScheme="blue"
              variant="outline"
            />
          </PopoverTrigger>
          <PopoverContent width={150}>
            <PopoverHeader display="flex" justifyContent="space-between">
              <span>{title ? title : "Spent Amounts"}</span>
              
            </PopoverHeader>
            <PopoverBody>
              <List spacing={2}>

                {spentAmounts && spentAmounts.length ?
                spentAmounts.map((amount, index) => (
                  <ListItem key={`spent_${index}`} display="flex">
                    <ListIcon mt={.8} as={AiFillInfoCircle} color="blue.600" />
                    {currencySymbol || "₹"} {formatAmountIndianRupees(amount)} 
                  </ListItem>
                ))
                :
                <ListItem display="flex">
                <ListIcon mt={0.9} as={AiFillInfoCircle} color="blue.600" />
                {currencySymbol || "₹"} {formatAmountIndianRupees(0)}
              </ListItem>
              }
              {refundAmount && refundAmount?.length > 0 &&
                refundAmount?.map((item, index) => (
                  <ListItem key={`refund_${index}`} display="flex">
                    <ListIcon mt={.8} as={AiFillInfoCircle} color="red.600" />
                    {currencySymbol || "₹"} {formatAmountIndianRupees(-item?.amt)} 
                  </ListItem>
                ))
               
              }
              </List>
            </PopoverBody>
          </PopoverContent>
        </>
      )}
    </Popover>
  );
};

export default SpentAmountPopover;
